import { ONE_MINUTE_MS } from "utilities/src/time/time";
export const DEFAULT_NATIVE_ADDRESS_LEGACY = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
export const DEFAULT_NATIVE_ADDRESS = "0x0000000000000000000000000000000000000000";
export const DEFAULT_RETRY_OPTIONS = { n: 10, minWait: 250, maxWait: 1e3 };
export const DEFAULT_MS_BEFORE_WARNING = ONE_MINUTE_MS * 10;
